import { useState, useCallback, useEffect } from 'react';
import { getListStaff } from 'api/staff';
import StaffDomain from 'domain/staff';
import ToastNotification from 'components/molecules/ToastNotification';
export const useStaffList = () => {

  const [staffList, setStaffList] = useState<Array<StaffDomain>>([]);
  const [orgCode, setOrgCode] = useState<any>(null);
  const [executiveId, setExecutiveId] = useState<any>(null);
  const [employmentId, setEmploymentId] = useState<any>(null);
  const [stateStatus, setStateStatus] = useState<any>(null);
  const [blocking, setBlocking] = useState(false);

  // Get list staff
  const fetchData = useCallback(async () => {
    if([orgCode, employmentId, executiveId, stateStatus].every(x=>x!==null)){
      setBlocking(true);
      if (stateStatus?.length === 0) {
        setBlocking(false);
        ToastNotification.error('状態を選択してください。');
        return;
      }
      const response = await getListStaff(
        orgCode,
        executiveId,
        employmentId,
        stateStatus,
      );  
      setStaffList(response.map((result) => new StaffDomain(result)));
      setBlocking(false);
    }
    
  }, [employmentId, executiveId, orgCode, stateStatus]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return {
    staffList,
    fetchData,
    executiveId,
    setExecutiveId,
    employmentId,
    setEmploymentId,
    orgCode,
    setOrgCode,
    stateStatus,
    setStateStatus,
    blocking,
  };
};

export default useStaffList;
